module.exports = __webpack_public_path__ + "img/Category.f6f7263.jpg";